<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <title>download-item</title>
            <g>
                <path fill="#343A40" d="M229.44,86h53.12a15.91,15.91,0,0,1,15.94,15.94V213.5h58.24a13.25,13.25,0,0,1,9.36,22.64l-101,101.07a12.85,12.85,0,0,1-18.13,0L145.83,236.14a13.26,13.26,0,0,1,9.37-22.64h58.3V101.94A15.91,15.91,0,0,1,229.44,86ZM426,335.69v74.37A15.91,15.91,0,0,1,410.06,426H101.94A15.91,15.91,0,0,1,86,410.06V335.69a15.91,15.91,0,0,1,15.94-15.94h97.42l32.53,32.54a34,34,0,0,0,48.22,0l32.53-32.54h97.42A15.91,15.91,0,0,1,426,335.69Zm-82.34,58.44a13.29,13.29,0,1,0-13.28,13.28A13.33,13.33,0,0,0,343.66,394.13Zm42.5,0a13.29,13.29,0,1,0-13.28,13.28A13.33,13.33,0,0,0,386.16,394.13Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdDownloadItemIcon',
        components: {
            MdIcon
        }
    }
</script>
